import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

//Import Section Title
import SectionTitle from "../common/section-title";
import ProcessBox from "./ProcessBox";

const Process = () => {
  const [state] = useState({
    processes: [
      {
        icon: "pe-7s-pen",
        title: "You build the product",
        desc: "The Big Oxmox advised her not to do so.",
      },
      {
        icon: "pe-7s-id",
        title: "We help you collect feedback on it",
        desc: "Little Blind Text didn't listen.",
      },
      {
        icon: "pe-7s-target",
        title: "Deliver a higher quality product",
        desc: "When she reached the first hills.",
      },
    ],
  });

  return (
    <React.Fragment>
      <section className="section bg-light">
        <Container>
          {/* section title */}
          <SectionTitle
            title="Process"
            desc=""
          />

          <Row>
            <Col lg={6} className="text-center process-left-icon-1">
              <i className="pe-7s-angle-right"></i>
            </Col>
            <Col lg={6} className="text-center process-left-icon-2">
              <i className="pe-7s-angle-right"></i>
            </Col>
          </Row>
          <Row className="mt-2">
            <ProcessBox processes={state.processes} />
            <div className="text-center mx-auto">
              <Link
                to="https://app.publicbacklog.com/user/login"
                className="btn btn-primary waves-light waves-effect mt-5"
              >
                Get Started <i className="mdi mdi-arrow-right"></i>
              </Link>
            </div>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Process;
